import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to top whenever the route pathname changes.
 * Skips reset when navigating to a hash anchor on the same page (#section).
 * Uses behavior: 'auto' to avoid jarring smooth-scroll on navigation
 * and to respect prefers-reduced-motion.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) return; // let the browser handle anchor scrolling
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, hash]);

    return null;
}
